function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import Base from './base';
import ActivityCollection from './activity_collection';
import $ from 'jquery';
import URI from 'urijs';

function normalizeAttrs(attrs) {
  if (attrs.id === -1) {
    attrs.name = Group.defaultName;
  }

  return attrs;
}

var Group = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Group, _Base);

  function Group() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Group.prototype;

  _proto.preinitialize = function preinitialize(attrs) {
    if (attrs === void 0) {
      attrs = {};
    } // Run it through our normalizer to perform any translations if necessary.


    attrs = normalizeAttrs(attrs);
  };

  _proto.initialize = function initialize() {
    var _this = this;

    _Base.prototype.initialize.apply(this, arguments);

    this.on('change:id', function (_, id) {
      _this.activities.group_id = id;
    });
  }
  /**
   * Convert this into the specified target type.
   * @param {string} targetType What to convert this into, e.g. `group`
   * @return {Promise}
   */
  ;

  _proto.convertTo = function convertTo(targetType) {
    var key = this.get('id') || this.get('permalink');
    var url = URI(this.urlRoot).segment(key.toString()).segment("convert_to_" + targetType).toString();
    return Backbone.ajax({
      url: url,
      method: 'post',
      dataType: 'json'
    });
  };

  _proto.markAsLoaded = function markAsLoaded() {
    this.set({
      loaded: true
    });
  };

  _proto.toggleCollapse = function toggleCollapse() {
    var toggle = !this.get('collapsed');

    if (this.isRealGroup()) {
      var opts = {
        patch: true,
        wait: true
      };
      return this.save({
        collapsed: toggle
      }, opts);
    } else {
      this.set({
        collapsed: toggle
      });
      return $.Deferred().resolve();
    }
  };

  _proto.url = function url(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return URI(_Base.prototype.url.apply(this, arguments)).setQuery(opts).toString();
  };

  _proto.validate = function validate(attrs) {
    if (attrs === void 0) {
      attrs = {};
    }

    if (attrs.name && !attrs.name.length) {
      return 'Group name cannot be empty.';
    }
  };

  _proto.isRealGroup = function isRealGroup() {
    return this.id !== Group.defaultId;
  };

  _proto.parse = function parse(attrs) {
    // Run it through our normalizer to perform any translations if necessary.
    attrs = normalizeAttrs(attrs);

    if (attrs.activities) {
      if (this.activities) {
        this.activities.set(attrs.activities);
      } else {
        this.activities = new ActivityCollection(attrs.activities, {
          group_id: this.id,
          user_id: this.get('owner_id')
        });
      }
    }

    return _Base.prototype.parse.apply(this, arguments);
  };

  _createClass(Group, [{
    key: "urlRoot",
    get: function get() {
      return '/api/groups';
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        id: null,
        name: 'New Group',
        collapsed: false,
        loaded: false,
        current: false
      };
    }
    /**
     * Read-only property to hold activity collection inside this group.
     * @return {ActivityCollection}
     */

  }, {
    key: "activities",
    get: function get() {
      var _this2 = this;

      if (!this._activities) {
        this._activities = new ActivityCollection(null, {
          group_id: this.id
        });
      } // Keep activities count attribute in sync with internal collection.


      this.listenTo(this._activities, 'update', function (activities) {
        _this2.set('activities_count', activities.length);
      });
      return this._activities;
    }
  }], [{
    key: "defaultName",
    get:
    /**
     * Returns the name for ungrouped groups that have an id === -1.
     * @return {string}
     */
    function get() {
      return 'Default';
    }
  }, {
    key: "defaultId",
    get: function get() {
      return -1;
    }
  }]);

  return Group;
}(Base);

export { Group as default };